export enum CommissionsGroupsEnum {
  SUB_ACCOUNT = "SUB_ACCOUNT",
  OFFER = "OFFER"
}